<div class="feature-svg-container d-flex flex-column align-items-center">
    <div class="position-relative">
        <svg class="feature-svg feature-svg--{{ size }}">
            <ng-container>
                @switch (svg) {
                    @case (FEATURE_SVG.AccessDenied) {
                        <svg:use
                            xlink:href="assets/images/svg/access-denied.svg#access-denied"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.AppNoGoals) {
                        <svg:use
                            xlink:href="assets/images/svg/app-no-goals.svg#app-no-goals"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.AppNoFamily) {
                        <svg:use
                            xlink:href="assets/images/svg/app-no-family.svg#app-no-family"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.AppNoProducts) {
                        <svg:use
                            xlink:href="assets/images/svg/app-no-products.svg#app-no-products"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.AppNoSourceOfWealth) {
                        <svg:use
                            xlink:href="assets/images/svg/app-no-source-of-wealth.svg#app-no-source-of-wealth"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.ClientCharity) {
                        <svg:use
                            xlink:href="assets/images/svg/client-charity.svg#client-charity"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.ClientCorporate) {
                        <svg:use
                            xlink:href="assets/images/svg/client-corporate.svg#client-corporate"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.ClientIndividual) {
                        <svg:use
                            xlink:href="assets/images/svg/client-individual.svg#client-individual"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.ClientJoint) {
                        <svg:use
                            xlink:href="assets/images/svg/client-joint.svg#client-joint"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.ClientTrust) {
                        <svg:use
                            xlink:href="assets/images/svg/client-trust.svg#client-trust"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.DashboardNoAccess) {
                        <svg:use
                            xlink:href="assets/images/svg/dashboard-no-access.svg#dashboard-no-access"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.EmptyFolder) {
                        <svg:use
                            xlink:href="assets/images/svg/empty-folder.svg#empty-folder"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.InboxEmpty) {
                        <svg:use
                            xlink:href="assets/images/svg/inbox-empty.svg#inbox-empty"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.NoChatData) {
                        <svg:use
                            xlink:href="assets/images/svg/no-chat-data.svg#no-chat-data"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.NoData) {
                        <svg:use
                            xlink:href="assets/images/svg/no-data.svg#no-data"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.NoListData) {
                        <svg:use
                            xlink:href="assets/images/svg/no-list-data.svg#no-list-data"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.PageNotFound) {
                        <svg:use
                            xlink:href="assets/images/svg/page-not-found.svg#page-not-found"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.SelectDataFromMenu) {
                        <svg:use
                            xlink:href="assets/images/svg/select-data-from-menu.svg#select-data-from-menu"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.Workspace) {
                        <svg:use
                            xlink:href="assets/images/svg/workspace.svg#workspace"
                        ></svg:use>
                    }
                    @case (FEATURE_SVG.Comments) {
                        <svg:use
                            xlink:href="assets/images/svg/comments.svg#comments"
                        ></svg:use>
                    }
                }
            </ng-container>
        </svg>
    </div>
    <h6 class="mt-3 text-center" data-cy="nothing-to-see-here">
        <ng-content></ng-content>
    </h6>
</div>
